// 选择主题列表
export const selectThemeMapList = [
  {
    text: "深蓝",
    value: "lanse",
    color: ["rgba(0,11,82,1)"],
  },
  {
    text: "黑金",
    value: "heijin",
    color: ["rgba(12,4,28,1)", "rgba(255,176,87,1)"],
  },
  {
    text: "灰色",
    value: "huise",
    color: ["rgba(162,162,162,1)"],
  },
  {
    text: "黑色",
    value: "chunheise",
    color: ["rgba(0,0,0,1)"],
  },
  {
    text: "青黑色",
    value: "qingheise",
    color: ["rgba(12,4,28,1)", "rgba(43,186,140,1)"],
  },
  {
    text: "白色",
    value: "baise",
    color: ["rgba(255,255,255,1)"],
  },
  {
    text: "蓝白",
    value: "lanbai",
    color: ["rgba(26,108,194,1)", "rgba(255,255,255,1)"],
  },
  {
    text: "紫色",
    value: "zise",
    color: ["rgba(193,193,229,1)"],
  },
  {
    text: "半透明",
    value: "bantouming",
    color: ["rgba(162,162,162,0.1)"],
  },
];
